import { createContext } from 'react';
import { initialState } from './AdvanceSearchModal.constants';

export const AdvanceSearchModalContext = createContext(initialState);
